import {ErrorMessageStyled} from "@/components/UI/Form/ErrorMessage/ErrorMessage.styled";

const ErrorMessage = ({meta, error, ...props}) => {
    if(meta?.error || error)
        return <ErrorMessageStyled {...props}>{meta?.error || error}</ErrorMessageStyled>

    return <></>
};

export default ErrorMessage;